import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { ArcLayer } from '@deck.gl/layers';
const defaultProps = {
  getHeight: {
    type: 'accessor',
    value: 0
  },
  greatCircle: true
};
export default class GreatCircleLayer extends ArcLayer {}

_defineProperty(GreatCircleLayer, "layerName", 'GreatCircleLayer');

_defineProperty(GreatCircleLayer, "defaultProps", defaultProps);
//# sourceMappingURL=great-circle-layer.js.map